import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {Tooltip as ReactTooltip} from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import AddPatient_form from '../Components/AddPatient_form';
import AddPatientCouple_form from '../Components/AddPatientCouple_form';
import EditPatient_form from '../Components/EditPatient_form';
import BasicTable from '../Components/Global_Components/reacttable/table';
import {patientid, setShowEditPopup, sidebar} from '../Redux/Slice/rootSlice';
import {getPatientsData} from '../Redux/Thunk/Actions';
import '../styles/Patients.scss';

dayjs.extend(localizedFormat);

function Patient({loaderchange, enableditview, popupalert, popuptext}) {
  const [tableheaderdata, settableheaderdata] = useState([]);
  const [datacount, setdatacount] = useState();
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [update, setUpdate] = useState(false);
  const viewpatient = useNavigate();
  const sideactive = useSelector(state => state.counter.sidebarnav);
  const userdata = useSelector(state => state.counter.userdata);
  const [branches, setbranches] = useState(() => {
    const saved = localStorage.getItem('patientPageBranch');
    return saved !== null ? saved : (localStorage.getItem('branch') || '');
  });
  const [allBranches] = useState(['Valasaravakkam', 'Vadapalani']);
  const [alert, setalert] = useState(false);
  const edituser = useSelector(state => state.counter.edituser);
  const adminuser = useNavigate();
  const [changeAlert, setChangeAlert] = useState(false);
  // const [roledata, setroledata] = useState("");
  const roledata = 'Super Admin';
  const [closeCreatePopup, setCloseCreatePopup] = useState(false);
  const [coupleCreatePopUp, setCoupleCreatePopUp] = useState(false);
  const showEditPopup = useSelector(state => state.counter.showEditPopup);
  const [creatuserinfo, setcreatuserinfo] = useState({
    phonenumber: '',
    email: '',
    first_name: '',
    last_name: '',
    title: '',
    district: '',
    city: '',
    zipcode: '',
    gender: '',
    birthdate: '',
    p_uhid: '',
    age: '',
    address: ''
  });
  const [error, seterror] = useState(false);

  const dispatch = useDispatch();
  const patientviewid = useDispatch();
  const [searchQuery, setSearchQuery] = useState('');
  const [search, setsearch] = useState(false);
  const [dateQuery, setDateQuery] = useState('');
  const [tempDate, setTempDate] = useState(dayjs().format('YYYY-MM-DD'));
  const [allPatientCheckBox, setAllPatientCheckBox] = useState(true);

  const dropdownhandlechange = (e, event) => {
    if (e) {
      viewpatient('/PatientView');
      dispatch(patientid(e));
      console.log(e);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const trimmedSearch = (searchQuery || '').trim();
      const dataPayload = {
        page: dtpageindex,
        page_size: dtpagesize,
        search: searchQuery,
        date: dateQuery,
        ...(!trimmedSearch && branches ? {branch: branches} : {}),
        ...((trimmedSearch || !branches) ? {skipBranchFilter: true} : {})
      };
      loaderchange('true');
      const patentDetails = getPatientsData(dataPayload);
      const responsePatentDetails = await dispatch(patentDetails);
      if (responsePatentDetails?.payload?.status?.code === 200) {
        setdatacount(responsePatentDetails.payload.total_count);
        settableheaderdata(responsePatentDetails.payload.data.data);
        loaderchange('false');
        setUpdate(false);
      } else {
        loaderchange('false');
        popupalert('true');
        popuptext('No Data Available');
        setTimeout(() => {
          popupalert('false');
        }, 2000);
      }
    };
    if (searchQuery != '') {
      const hasNumbers = /[0-9]/.test(searchQuery);
      const hasLetters = /[a-zA-Z]/.test(searchQuery);
      const hasSpecialChars = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/.test(searchQuery);
      if (hasNumbers || hasLetters || hasSpecialChars) {
        fetchData();
      }
    } else {
      fetchData();
    }
  }, [dtpageindex, dtpagesize, search, dateQuery, searchQuery, branches, update]);

  const handleBranchChange = (e) => {
    const selectedBranch = e.target.value;
    setbranches(selectedBranch);
    localStorage.setItem('patientPageBranch', selectedBranch);
    localStorage.removeItem('selectedBranch'); // Cleanup to avoid global side effects
    setUpdate(true);
  };

  const columns = useMemo(
    () => [
      {
        Header: 'Patient ID',
        accessor: '',
        Cell: row => {
          // console.log(row.row.original.username)
          return (
            <>
              <span>
                <div style={{marginTop: '3px'}} data-tooltip-id='my-tooltip' data-tooltip-content={String(row.row.original.p_uhid)}>
                  {String(row.row.original.p_uhid)}
                </div>
              </span>
            </>
          );
        }
      },
      {
        Header: 'Name',
        accessor: '',
        Cell: row => {
          // console.log(row.row.original.username)
          return (
            <>
              <span>
                <div
                  style={{marginTop: '3px'}}
                  data-tooltip-id='my-tooltip'
                  data-tooltip-content={String(row.row.original.titles + ' ' + row.row.original.first_name + ' ' + row.row.original.last_name)}>
                  {String(row.row.original.titles + ' ' + row.row.original.first_name + ' ' + row.row.original.last_name)}
                </div>
              </span>
            </>
          );
        }
      },

      {
        Header: 'Email',
        accessor: '',
        Cell: row => {
          // console.log(row.row.original.username)
          return (
            <>
              <span>
                <div style={{marginTop: '3px'}} data-tooltip-id='my-tooltip' data-tooltip-content={String(row.row.original.email)}>
                  {/* {String(row.row.original.email)} */}
                  {row.row.original.email === null ? '--' : row.row.original.email}
                </div>
              </span>
            </>
          );
        }
      },

      {
        Header: 'PhoneNumber',
        accessor: '',
        Cell: row => {
          // console.log(row.row.original.username)
          return (
            <>
              <span>
                <div style={{marginTop: '3px'}} data-tooltip-id='my-tooltip' data-tooltip-content={String(row.row.original.phonenumber)}>
                  {String(row.row.original.phonenumber)}
                </div>
              </span>
            </>
          );
        }
      },
      {
        Header: 'Date',
        accessor: '',
        Cell: row => {
          // console.log(row.row.original)
          const rawDate = row.row.original.created_date.split('T')[0];
          const date = rawDate.split('-').reverse().join('-');

          return (
            <>
              <span>
                <div style={{marginTop: '3px'}} data-tooltip-id='my-tooltip' data-tooltip-content={date}>
                  {String(date)}
                </div>
              </span>
            </>
          );
        }
      },

      // {
      //   Header: "Address",
      //   accessor: "",
      //   Cell: (row) => {
      //     return (
      //       <>
      //         <p
      //           data-tooltip-id="my-tooltip"
      //           data-tooltip-content={row.row.original.address}
      //         >
      //           {row.row.original.address === null
      //             ? "-"
      //             : row.row.original.address}{" "}
      //         </p>
      //       </>
      //     );
      //   },
      // },

      {
        Header: 'Actions',
        accessor: '',
        Cell: row => {
          return (
            <div className='style'>
              <button type='button' class='btn btn-danger btn-sm delete' style={{display: 'flex', gap: '4px'}} onClick={e => editPatientPopup(row.row.original.id, e)}>
                <i onClick={e => editPatientPopup(row.row.original.id, e)} class='bi bi-pencil'></i> Edit
              </button>
              <button type='button' class='btn btn-danger btn-sm delete' style={{display: 'flex', gap: '4px'}} onClick={e => dropdownhandlechange(row.row.original.id, e)}>
                <i onClick={e => dropdownhandlechange(row.row.original.id, e)} class='bi bi-eye-fill'></i> View
              </button>
            </div>
          );
        }
      }
    ],
    []
  );

  const createPatient = e => {
    setCloseCreatePopup(true);
  };
  const editPatientPopup = e => {
    dispatch(patientid(e));
    dispatch(setShowEditPopup(true));
  };

  const [finalPatientsData, setFinalPatientsData] = useState('');

  const pagesize = arg => {
    setdtPagesize(arg);
  };

  const pageindex = arg => {
    setdtPageindex(arg);
  };
  const handleSubmit = event => {
    event.preventDefault();
  };

  const patientId = useSelector(state => state.counter.patientid);

  return (
    <div className={sideactive ? 'maincontainer-patient-sa' : 'maincontainer-patient'}>
      {closeCreatePopup && (
        <AddPatient_form
          setCloseCreatePopup={setCloseCreatePopup}
          setCoupleCreatePopUp={setCoupleCreatePopUp}
          loaderchange={loaderchange}
          popupalert={popupalert}
          popuptext={popuptext}
          setUpdate={setUpdate}
        />
      )}
      {coupleCreatePopUp && (
        <AddPatientCouple_form
          setCloseCreatePopup={setCloseCreatePopup}
          setCoupleCreatePopUp={setCoupleCreatePopUp}
          loaderchange={loaderchange}
          popupalert={popupalert}
          popuptext={popuptext}
          setUpdate={setUpdate}
        />
      )}
      {showEditPopup && <EditPatient_form setCoupleCreatePopUp={setCoupleCreatePopUp} loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} setUpdate={setUpdate} />}
      <div className='patient-header'>
        <div className='row'>
          <div className='col'>
            <h3 className='page-title'>Patient</h3>
            <ul className='breadcrumb'>
              <li className='breadcrumb-item'>
                <a
                  href='/'
                  style={{textDecoration: 'none', color: 'black'}}
                  onClick={e => {
                    dispatch(sidebar('DashBoard'));
                  }}>
                  Dashboard
                </a>
              </li>
              <li className='breadcrumb-item active'>Patient</li>
            </ul>
          </div>
        </div>
        <div className='add_btn' style={{display: 'flex', gap: '40px', alignItems: 'center'}}>
          <div className='branch_select'>
              <select
                className="form-select"
                value={branches}
                onChange={handleBranchChange}
                style={{
                  height: "40px",
                  borderRadius: "6px",
                  border: "1px solid #ddd",
                  padding: "0 10px",
                  backgroundColor: "white",
                  cursor: "pointer",
                  minWidth: "150px",
                  marginBottom: "20px"
                }}
              >
                <option value="">All Branches</option>
                {[...new Set([...allBranches, ...(branches ? [branches] : [])])].map((branch) => (
                  <option key={branch} value={branch}>
                    {branch}
                  </option>
                ))}
              </select>
          </div>
          <button onClick={e => createPatient(e)} className='btn_1'>
            Add
          </button>
        </div>
        {/* <div class="col-sm-5 col">
          <a
            
            style={{
              backgroundColor: "#1b5a90",
              border: "1px solid #1b5a90",
              color: "white",
            }}
            type="button"
            data-toggle="modal"
            class="btn btn-primary float-right mt-2"
          >
            Add
          </a>
        </div> */}
      </div>
      <div className='row' style={{marginTop: 20}}>
        <div className='col-lg-12'>
          <div className='card'>
            <div className='card-body'>
              <div className='patient'>
                <div className='table-content-patient'>
                  <form onSubmit={handleSubmit} style={{display: 'flex', justifyContent: 'space-between'}}>
                    <div class='input-group rounded' style={{width: '250px', height: '40px'}}>
                      <input
                        type='search'
                        class='form-control rounded'
                        aria-label='Search'
                        aria-describedby='search-addon'
                        // value={searchQuery}
                        style={{
                          height: '40px'
                        }}
                        // onKeyDown={(e) => {
                        //   if (e.target.value.length === 0 && e.which === 32) {
                        //     e.preventDefault();
                        //   }
                        // }}

                        // onInput={(e) => {
                        //   if (e.target.value.length <= "100") {
                        //     setSearchQuery(e.target.value);
                        //   } else {
                        //     e.preventDefault();
                        //   }
                        // }}

                        onChange={e => {
                          const time = setTimeout(() => {
                            setSearchQuery(e.target.value);

                            // if (e.target.value =="") {
                            // setDateQuery(tempDate);
                            // setSearchQuery("");
                            // } else {
                            //   setDateQuery("");
                            //   setSearchQuery(e.target.value);
                            // }
                          }, 800);
                        }}
                        // onKeyDown={(e)=>{if(e.which=="32"){
                        //   e.preventDefault()
                        // }}}

                        min='0'
                        max='10'
                        label='Search'
                        placeholder='Search...'
                        required
                      />
                      <span class='input-group-text border-0 bg-transparent p-0' id='search-addon'>
                        <i
                          class='bi bi-search'
                          style={{
                            color: '#1b5a90',
                            width: '20px',
                            height: '20px',
                            marginLeft: '10px'
                          }}></i>
                      </span>
                    </div>
                    {/* //*date filter */}
                    <div
                      style={{
                        display: 'flex',
                        gap: '10px'
                      }}>
                      {/* <select
                        name="status"
                        style={{ width: "200px", height: "40px" }}
                        className="form-control rounded"
                        onChange={(e)=>{
                          // setReportStatus(e.target.value)
                        }}
                      >
                        <option selected disabled>select</option>
                        <option value="">
                          All
                        </option>
                        
                      </select> */}
                      <div className='patientsAllcheckbox form-control rounded'>
                        <label>All Patients</label>
                        <input
                          type='checkbox'
                          checked={allPatientCheckBox}
                          onChange={e => {
                            if (e.target.checked) {
                              setDateQuery('');
                              setAllPatientCheckBox(true);
                            } else {
                              setdtPageindex(1);
                              setDateQuery(tempDate);
                              setAllPatientCheckBox(false);
                            }
                          }}
                        />
                      </div>
                      <input
                        style={{width: '200px', height: '40px'}}
                        defaultValue={dateQuery}
                        className='form-control rounded'
                        type='date'
                        onChange={e => {
                          setDateQuery(e.target.value);
                          setTempDate(e.target.value);
                          setAllPatientCheckBox(false);

                          // setSearchQuery("");
                        }}
                      />
                    </div>
                    {/* <div
                      style={{
                        display: "flex",
                        gap: "10px",
                      }}
                    >
                      {roledata == "Super Admin" && (
                        <>
                          <div
                            class="input-group rounded mr-2 "
                            style={{ width: "250px", height: "40px" }}
                          >
                            <select
                              class="form-select"
                              value={branches}
                              name="gender"
                              onChange={(e) => {
                                setbranches(e.target.value);
                              }}
                            >
                              <option selected disabled value="">
                                Filter By Location...
                              </option>
                              <option value={"0"}>VELACHERY</option>
                              <option value={"1"}>CHETPET</option>
                              <option value={"2"}>KOLATHUR</option>
                            </select>
                          </div>
                        </>
                      )}
                    </div> */}
                  </form>

                  <div className='table-patient'>
                    <BasicTable columns={columns} data={tableheaderdata} pagesize={pagesize} pageindex={pageindex} dtpagesize={dtpagesize} dtpageindex={dtpageindex} datacount={datacount} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ReactTooltip
        id='my-tooltip'
        arrowColor='transparent'
        place='bottom-start'
        delayShow={200}
        style={{
          backgroundColor: '#707070',
          fontSize: '10px',
          textAlign: 'center',
          padding: '5px',
          fontWeight: 400
        }}
      />
    </div>
  );
}

export default Patient;

